function Access() {
  return (
    <div className="access section">
      <h2 className="title">
        <img src="images/yodogawa-3.png" alt="開催場所" />
      </h2>
      <div className="locations">
        <ul>
          <li>
            <div className="location">
              <h3>さくらであい館</h3>
              <div className="map">
                <img src="images/yodogawa-15.png" alt="" />
              </div>
              <div className="info">
                〒614-8307
                <br />
                京都府八幡市八幡在応寺地先
                <br />
                電話番号/075-633-5120
                <br />
                最寄駅/京阪本線・石清水八幡宮駅
              </div>
            </div>
          </li>
          <li>
            <div className="location">
              <h3>レンタルスペース ビィーゴ</h3>
              <div className="map">
                <img src="images/yodogawa-13.png" alt="" />
              </div>
              <div className="info">
                〒573-0031 <br />
                枚方市岡本町7-1枚方ビオルネ5階
                <br />
                電話番号/072-800-1919 <br />
                最寄駅/京阪本線・枚方市駅
              </div>
            </div>
          </li>
          <li>
            <div className="location">
              <h3>大阪産業創造館</h3>
              <div className="map">
                <img src="images/yodogawa-14.png" alt="" />
              </div>
              <div className="info">
                〒541-0053 <br />
                大阪市中央区本町1-4-5
                <br />
                電話番号/06-6264-9911 <br />
                最寄駅/Osaka Metro 中央線・堺筋線・堺筋本町駅
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Access;
